import { Capacitor } from '@capacitor/core';

// Determine the API URL based on the platform
export const getApiUrl = () => {
  // Debug logging
  console.log('[API Config] Platform check:', {
    isNative: Capacitor.isNativePlatform(),
    platform: Capacitor.getPlatform(),
    isDev: import.meta.env.DEV,
    mode: import.meta.env.MODE,
  });

  // Check if we're running in Capacitor (mobile app)
  if (Capacitor.isNativePlatform()) {
    // Debug: Log the actual value of the environment variable
    console.log('[API Config] VITE_USE_LOCAL_API value:', import.meta.env.VITE_USE_LOCAL_API);
    console.log('[API Config] VITE_USE_LOCAL_API type:', typeof import.meta.env.VITE_USE_LOCAL_API);
    console.log('[API Config] All env vars:', import.meta.env);

    // Check if we want to use local API for development
    if (import.meta.env.VITE_USE_LOCAL_API === 'true') {
      // Use the local API URL from environment variables, with a fallback for backward compatibility.
      // Developers should define VITE_LOCAL_API_URL in their .env.local file.
      const localApiUrl = import.meta.env.VITE_LOCAL_API_URL || 'https://192.168.1.136:5050';
      console.log('[API Config] Using LOCAL API for mobile development:', localApiUrl);
      return localApiUrl;
    }

    // Production API (default) - use environment variable or fallback
    const productionApiUrl = import.meta.env.VITE_API_URL || 'https://yapzap-backend-production.up.railway.app';
    console.log('[API Config] Using production API URL for mobile app:', productionApiUrl);
    return productionApiUrl;
  }

  // For web - check if we have an explicit API URL set
  // This handles both development (empty for Vite proxy) and production
  const apiUrl = import.meta.env.VITE_API_URL;

  // If VITE_API_URL is explicitly set, use it (production case)
  if (apiUrl) {
    console.log('[API Config] Using VITE_API_URL for web:', apiUrl);
    return apiUrl;
  }

  // If not set and we're in development mode, use Vite proxy
  if (import.meta.env.MODE === 'development') {
    console.log('[API Config] Using Vite proxy for development');
    return '';
  }

  // Fallback for production without VITE_API_URL
  console.log('[API Config] Using fallback production API URL');
  return 'https://yapzap-backend-production.up.railway.app';
};

// Helper function to create full API URL
export const apiUrl = (path: string) => {
  const baseUrl = getApiUrl();
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};
